import { action, makeObservable, observable } from 'mobx';

class BoostedJackpotStore {
  isWheel = false;

  wheelValues = [];

  sectorStopIndex = null;

  winningCount = 0;

  lastWinnerDate = '';

  prizePoolAmount = 0;

  lastWinnerAmount = 0;

  winningCountLeft = 0;

  largestWinnerDate = '';

  boostedBetAmount = null;

  largestWinnerAmount = 0;

  prizePoolLeftAmount = 0;

  isBoostedJackpot = false;

  spinWheelWinAmount = null;

  playerBoostedWinAmount = 0;

  boostedJackpotEndTime = '';

  boostedInitialBetAmount = 0;

  isBoostedJackpotWinPopup = false;

  isBoostedJackpotInfoPopup = false;

  constructor() {
    makeObservable(this, {
      isWheel: observable,
      winningCount: observable,
      lastWinnerDate: observable,
      sectorStopIndex: observable,
      prizePoolAmount: observable,
      boostedBetAmount: observable,
      lastWinnerAmount: observable,
      isBoostedJackpot: observable,
      winningCountLeft: observable,
      largestWinnerDate: observable,
      spinWheelWinAmount: observable,
      largestWinnerAmount: observable,
      prizePoolLeftAmount: observable,
      boostedJackpotEndTime: observable,
      playerBoostedWinAmount: observable,
      boostedInitialBetAmount: observable,
      isBoostedJackpotWinPopup: observable,
      isBoostedJackpotInfoPopup: observable,
      wheelValues: observable.deep,

      setIsWheel: action.bound,
      setWheelValues: action.bound,
      setWinningCount: action.bound,
      setLastWinnerDate: action.bound,
      setPrizePoolAmount: action.bound,
      setSectorStopIndex: action.bound,
      setBoostedBetAmount: action.bound,
      setLastWinnerAmount: action.bound,
      setWinningCountLeft: action.bound,
      setIsBoostedJackpot: action.bound,
      setLargestWinnerDate: action.bound,
      setSpinWheelWinAmount: action.bound,
      setLargestWinnerAmount: action.bound,
      setPrizePoolLeftAmount: action.bound,
      setBoostedJackpotEndTime: action.bound,
      setPlayerBoostedWinAmount: action.bound,
      setBoostedInitialBetAmount: action.bound,
      setIsBoostedJackpotWinPopup: action.bound,
      setIsBoostedJackpotInfoPopup: action.bound,
    });
  }

  setIsWheel(bool) {
    this.isWheel = bool;
  }

  setWheelValues(data) {
    this.wheelValues = data;
  }

  setSectorStopIndex(index) {
    this.sectorStopIndex = index;
  }

  setBoostedBetAmount(betAmount) {
    this.boostedBetAmount = betAmount;
  }

  setBoostedInitialBetAmount(betAmount) {
    this.boostedInitialBetAmount = betAmount;
  }

  setPlayerBoostedWinAmount(betAmount) {
    this.playerBoostedWinAmount = betAmount;
  }

  setSpinWheelWinAmount(amount) {
    this.spinWheelWinAmount = amount;
  }

  setWinningCount(num) {
    this.winningCount = num;
  }

  setLastWinnerDate(date) {
    this.lastWinnerDate = date;
  }

  setIsBoostedJackpot(bool) {
    this.isBoostedJackpot = bool;
  }

  setWinningCountLeft(num) {
    this.winningCountLeft = num;
  }

  setLastWinnerAmount(num) {
    this.lastWinnerAmount = num;
  }

  setPrizePoolAmount(num) {
    this.prizePoolAmount = num;
  }

  setLargestWinnerDate(date) {
    this.largestWinnerDate = date;
  }

  setPrizePoolLeftAmount(num) {
    this.prizePoolLeftAmount = num;
  }

  setLargestWinnerAmount(num) {
    this.largestWinnerAmount = num;
  }

  setBoostedJackpotEndTime(time) {
    this.boostedJackpotEndTime = time;
  }

  setIsBoostedJackpotWinPopup(bool) {
    this.isBoostedJackpotWinPopup = bool;
  }

  setIsBoostedJackpotInfoPopup(bool) {
    this.isBoostedJackpotInfoPopup = bool;
  }
}

export const boostedJackpotStore = new BoostedJackpotStore();
